"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const AdapterDateFns_1 = tslib_1.__importDefault(require("@mui/lab/AdapterDateFns"));
const LocalizationProvider_1 = tslib_1.__importDefault(require("@mui/lab/LocalizationProvider"));
const CssBaseline_1 = tslib_1.__importDefault(require("@mui/material/CssBaseline"));
const styles_1 = require("@mui/material/styles");
const locale_1 = require("date-fns/locale");
const createTheme_1 = tslib_1.__importDefault(require("@eduzz/houston-styles/createTheme"));
const Container_1 = tslib_1.__importDefault(require("../Toast/Container"));
const _generator_1 = tslib_1.__importDefault(require("./_generator"));
const _state_1 = require("./_state");
const defaultTheme = (0, createTheme_1.default)('orbita');
function ThemeProvider({ theme = defaultTheme, children, disableCssBaseline, disabledFontBase, disableToast }) {
    const [muiTheme] = React.useState(() => (0, _generator_1.default)(theme));
    const [styleContent] = React.useState(() => ({
        __html: `
        form { width: 100%; }
        a { text-decoration: none; }
        .houston-icon { line-height: 0; }

        ${!disabledFontBase &&
            `
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700');

        body {
          font-family: ${theme.font.family.base};
          font-size: ${theme.font.size.xs};
          -webkit-font-smoothing: auto;
        }
      `}
      `
    }));
    React.useEffect(() => (0, _state_1.setCurrentTheme)(theme), [theme]);
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledEngineProvider, Object.assign({ injectFirst: true }, { children: (0, jsx_runtime_1.jsx)(styles_1.ThemeProvider, Object.assign({ theme: muiTheme }, { children: (0, jsx_runtime_1.jsxs)(LocalizationProvider_1.default, Object.assign({ locale: locale_1.ptBR, dateAdapter: AdapterDateFns_1.default }, { children: [(0, jsx_runtime_1.jsx)("style", { dangerouslySetInnerHTML: styleContent }), !disableToast && (0, jsx_runtime_1.jsx)(Container_1.default, {}), !disableCssBaseline && (0, jsx_runtime_1.jsx)(CssBaseline_1.default, {}), children] })) })) })));
}
exports.default = React.memo(ThemeProvider);
